import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '@/views/index/index')
  },
  {
    path: '/theme1',
    name: 'theme1',
    component: () => import(/* webpackChunkName: "about" */ '@/views/theme1/index')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
